import React from "react";
import i18n from "../../../i18n";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";

export class DashboardWalletData extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() { }

  render() {
    let { wallet_data } = this.props;
    return (
      <React.Fragment>
        <div className="container mb-3 px-0">
          <div className="row user-brd  rounded-4">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="">
                <div className="py-3">
                  <div className="rounded-4">
                    <div className="grid_container grid_mob_container">
                      <div
                        className="wallet-card wallet-card-deposit"
                        onClick={() => {
                          window.location.href = "/users-wallet";
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="wallet-card-inner">
                          <div className="gap-3" style={{ display: "flex", textAlign: "center", alignItems: "center" }}>
                            <div className="wallet-icon-badge deposit-badge">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
                                <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
                                <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
                              </svg>
                            </div>
                            <div className="wallet-label">{i18n.t("deposit")}</div>
                          </div>
                          <div className="wallet-amount">
                            <span className="amount-value">{wallet_data.credit_sum || 0}</span>
                            <SaudiRiyalLogo />
                          </div>
                        </div>
                        <div className="wallet-card-gradient deposit-gradient"></div>
                      </div>

                      <div
                        className="wallet-card wallet-card-due"
                        onClick={() => {
                          window.location.href = "/users-wallet";
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="wallet-card-inner">
                          <div className="gap-3" style={{ display: "flex", textAlign: "center", alignItems: "center" }}>
                            <div className="wallet-icon-badge due-badge">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                                <polyline points="16 7 22 7 22 13" />
                              </svg>
                            </div>
                            <div className="wallet-label">{i18n.t("client_due")}</div>
                          </div>
                          <div className="wallet-amount">
                            <span className="amount-value">{wallet_data.client_due || 0}</span>
                            <SaudiRiyalLogo />
                          </div>
                        </div>
                        <div className="wallet-card-gradient due-gradient"></div>
                      </div>

                      <div
                        className="wallet-card wallet-card-hold"
                        onClick={() => {
                          window.location.href = "/users-wallet";
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="wallet-card-inner">
                          <div className="gap-3" style={{ display: "flex", textAlign: "center", alignItems: "center" }}>
                            <div className="wallet-icon-badge hold-badge">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                              </svg>
                            </div>
                            <div className="wallet-label">{i18n.t("hold")}</div>
                          </div>
                          <div className="wallet-amount">
                            <span className="amount-value">{wallet_data.hold_sum || 0}</span>
                            <SaudiRiyalLogo />
                          </div>
                        </div>
                        <div className="wallet-card-gradient hold-gradient"></div>
                      </div>

                      <div
                        className="wallet-card wallet-card-withdraw"
                        onClick={() => {
                          window.location.href = "/users-wallet";
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="wallet-card-inner">
                          <div className="gap-3" style={{ display: "flex", textAlign: "center", alignItems: "center" }}>
                            <div className="wallet-icon-badge withdraw-badge">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                                <polyline points="16 17 22 17 22 11" />
                              </svg>
                            </div>
                            <div className="wallet-label">{i18n.t("withdraw")}</div>
                          </div>

                          <div className="wallet-amount">
                            <span className="amount-value">{wallet_data.debit_sum || 0}</span>
                            <SaudiRiyalLogo />
                          </div>
                        </div>
                        <div className="wallet-card-gradient withdraw-gradient"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .wallet-card {
            position: relative;
            background: white;
            border-radius: 16px;
            padding: 24px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
            overflow: hidden;
          }

          .wallet-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          }

          .wallet-card-inner {
            position: relative;
            z-index: 2;
          }

          .wallet-icon-badge {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 16px;
            transition: transform 0.3s ease;
          }

          .wallet-card:hover .wallet-icon-badge {
            transform: scale(1.1);
          }

          .deposit-badge {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: white;
          }

          .due-badge {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
          }

          .hold-badge {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            color: white;
          }

          .withdraw-badge {
            background: linear-gradient(135deg, #f43f5e 0%, #e11d48 100%);
            color: white;
          }

          .wallet-label {
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            color: #64748b;
            margin-bottom: 12px;
          }

          .wallet-amount {
            display: flex;
            align-items: baseline;
            gap: 6px;
          }

          .amount-value {
            font-size: 28px;
            font-weight: 700;
            color: #1e293b;
          }

          .wallet-card-gradient {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 4px;
            transform: scaleX(0);
            transition: transform 0.3s ease;
          }

          .wallet-card:hover .wallet-card-gradient {
            transform: scaleX(1);
          }

          .deposit-gradient {
            background: linear-gradient(90deg, #10b981 0%, #059669 100%);
          }

          .due-gradient {
            background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
          }

          .hold-gradient {
            background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
          }

          .withdraw-gradient {
            background: linear-gradient(90deg, #f43f5e 0%, #e11d48 100%);
          }

          @media (max-width: 768px) {
            .wallet-card {
              padding: 20px;
            }

            .amount-value {
              font-size: 24px;
            }

            .wallet-icon-badge {
              width: 40px;
              height: 40px;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}